import { define } from 'wicked-elements'

define('[data-component~="logo-colors"]', {
  init () {
    this.$triggers = [...document.querySelectorAll('[data-color-trigger]')]
    this.$dotTriggers = this.$triggers.filter($el => $el.dataset.colorTrigger)
    this.$eggTriggers = this.$triggers.filter($el => $el.dataset.colorTrigger === 'special')
    this.handleDotEnter = this.handleDotEnter.bind(this)
    this.handleDotLeave = this.handleDotLeave.bind(this)
    this.handleEggEnter = this.handleEggEnter.bind(this)
    this.handleEggLeave = this.handleEggLeave.bind(this)
    this.isTouch = window.matchMedia('(hover: none)').matches
  },
  connected () {
    if (this.isTouch) return
    this.$dotTriggers.forEach($el => {
      $el.addEventListener('mouseenter', this.handleDotEnter)
      $el.addEventListener('mouseleave', this.handleDotLeave)
    })
    this.$eggTriggers.forEach($el => {
      $el.addEventListener('mouseenter', this.handleEggEnter)
      $el.addEventListener('mouseleave', this.handleEggLeave)
    })
  },
  disconnected () {
    if (this.isTouch) return
    this.$dotTriggers.forEach($el => {
      $el.removeEventListener('mouseenter', this.handleDotEnter)
      $el.removeEventListener('mouseleave', this.handleDotLeave)
    })
    this.$eggTriggers.forEach($el => {
      $el.removeEventListener('mouseenter', this.handleEggEnter)
      $el.removeEventListener('mouseleave', this.handleEggLeave)
    })
  },
  handleDotEnter (e) {
    let color = e.target.dataset.colorTrigger
    document.documentElement.classList.add(`activate-${color}`)
  },
  handleDotLeave (e) {
    let color = e.target.dataset.colorTrigger
    document.documentElement.classList.remove(`activate-${color}`)
  },
  handleEggEnter () {
    document.documentElement.classList.add(`activate-colorful`)
  },
  handleEggLeave () {
    document.documentElement.classList.remove(`activate-colorful`)
  }
})